import { render, staticRenderFns } from "./matchmakerCase.vue?vue&type=template&id=e90f9728&scoped=true"
import script from "./matchmakerCase.vue?vue&type=script&lang=js"
export * from "./matchmakerCase.vue?vue&type=script&lang=js"
import style0 from "./matchmakerCase.vue?vue&type=style&index=0&id=e90f9728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90f9728",
  null
  
)

export default component.exports